import script from "./FiltersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersPage.vue?vue&type=script&setup=true&lang=js"

import "./FiltersPage.vue?vue&type=style&index=0&id=6f6cd328&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6cd328"]])

export default __exports__